import react, { useEffect } from "react";

// import { amplitude } from "./amplitude/amplitude";
import "./App.css";
import { Home } from "./home/Home";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Book, BookId } from "./types";
import { TrackerScreen } from "./trackerScreen/trackerScreen";
import { areAnyBooks, last } from "./utils";
import { Library } from "./Library/Library";
import { AddBook } from "./AddBook";
// import { track } from "@amplitude/analytics-browser";
import * as amplitude from "@amplitude/analytics-browser";

const App = () => {
  const [books, setBooks] = react.useState<Record<string, Book>>({});
  const [loading, setLoading] = react.useState<boolean>(true);
  const [lastBooksRead, setLastBooksRead] = react.useState<string[]>([]);

  react.useEffect(() => {
    const localBooks = localStorage.getItem("books");
    const localLastBookRead = localStorage.getItem("lastBooksRead");
    if (localBooks) {
      const localBooksParsed = JSON.parse(localBooks);
      setBooks(localBooksParsed || {});

      const identifyEvent = new amplitude.Identify();
      identifyEvent.set("user-books", localBooksParsed.length);
      amplitude.identify(identifyEvent);
    }
    if (localLastBookRead) {
      const localLastBookReadParsed = JSON.parse(localLastBookRead);
      setLastBooksRead(localLastBookReadParsed);
    }
    setLoading(false);
  }, []);
  react.useEffect(() => {
    setLoading(true);
    if (books && areAnyBooks(books)) {
      localStorage.setItem("books", JSON.stringify(books || {}));
    }
    setLoading(false);
  }, [books]);
  react.useEffect(() => {
    if (lastBooksRead.length > 0) {
      localStorage.setItem("lastBooksRead", JSON.stringify(lastBooksRead));
    }
  }, [lastBooksRead]);
  const handleChangeLastBooksRead = (newId: BookId, remove?: Boolean) => {
    if (remove) {
      setLastBooksRead((list) => {
        const newArr = [...list];
        newArr.splice(list.indexOf(newId), 1);
        return newArr;
      });
      return;
    }
    setLastBooksRead((list) => {
      const index = list.indexOf(newId);
      if (index === -1) {
        return [...list, newId];
      }
      const newlist = [...list];
      newlist.splice(index, 1);

      newlist.push(newId);
      return newlist;
    });
  };
  const props = {
    lastBooksRead,
    setLastBooksRead: handleChangeLastBooksRead,
    books,
    setBooks,
  };
  return !loading ? (
    <div className="App">
      <div className="App-content">

      <BrowserRouter>
        <Routes>
          <Route path="/home" element={<Home {...props} />} />
          <Route path="/addBook" element={<AddBook {...props} />} />
          <Route path="/library" element={<Library {...props} />} />
          <Route path="/tracker/:id" element={<TrackerScreen {...props} />} />
          <Route
            path="*"
            element={
              <Navigate
                to={
                  areAnyBooks(books) && lastBooksRead?.length > 0
                    ? `/tracker/${last(lastBooksRead)}`
                    : "/home"
                }
                replace
              />
            }
          />
        </Routes>
      </BrowserRouter>
      </div>
    </div>
  ) : null;
};

export default App;
